<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text style="width:280px !important; padding: 0px 10px;" v-html="content"></v-card-text>
        <v-card-text style="width:280px !important; padding: 0px 10px;" v-html="error"></v-card-text>
        <v-card-actions>
          <div class="danger-alert" v-if="error">
            {{error}}
          </div>
          <v-spacer></v-spacer>
          <v-btn color="pink" flat @click="remove">{{ confirmText ? confirmText : $t('dialog.warning.delete') }}</v-btn>
          <v-btn color="primary" flat @click="cancel">{{ $t('dialog.warning.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: [
    'title',
    'content',
    'dialog',
    'closeDialog',
    'confirmText'
  ],
  data () {
    return {
      error: null
    };
  },
  methods: {
    remove () {
      this.closeDialog('ok');
    },
    cancel () {
      this.closeDialog(undefined);
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/popup/WarningDialog.vue